import { Link } from "react-router-dom";
import "../Css/home.css";

export default function ProjectsCards({ img, title, discription, link }) {
  return (
    <div className="Project-cards">
      <div className="cards-img">
        <Link to={link}>
          <img src={img} alt={title} />
        </Link>
      </div>
      <div className="cards-heading">
        <h4>{title}</h4>
        <span>{discription}</span>
      </div>
    </div>
  );
}
